// extracted by mini-css-extract-plugin
module.exports = {"QuizAnswerContainer":"QuizAnswer_QuizAnswerContainer__FpKLc","Letter":"QuizAnswer_Letter__27fdg","Ansrow":"QuizAnswer_Ansrow__2OEKA"};